import React from 'react'
import {
  $DCSuccessColor,
  $DCSuccessLightColor,
  DcDiv,
  DcFlexBox,
  DcTag,
  PixelCurrency,
  PixelDate,
  PixelText,
  SectionContent,
  SectionHeader,
  SectionTitle,
} from 'pixel-base'
interface PurchaseData {
  id: number
  ems_customer_id: number
  reference_number: string
  total_amount: number
  notes: string
  user: number
  supplier: {
    id: number
    supplier_name: string
    contact_person: string
    phone: string
  }
  purchase_status: {
    id: number
    status: string
    description: string
    is_final_status: boolean
    is_default: boolean | null
  }
  warehouse: {
    id: number
    name: string
  }
  created_at: {
    date: string // e.g., "2025-06-03 10:04:15.000000"
    timezone_type: number
    timezone: string // e.g., "UTC"
  }
  purchase_items: any[] // Replace `any` with appropriate type if structure is known
}

const PurchaseSummary = ({
  purchaseSummary,
}: {
  purchaseSummary: PurchaseData
}) => {
  return (
    <>
      <DcFlexBox height="auto" gap="20px">
        <SectionContent style={{ width: '70%' }}>
          <SectionHeader
            style={{
              padding: '1.5rem 1.5rem 0 1.5rem',
              borderBottom: '1px solid #f3f4f6',
              marginBottom: '1.5rem',
            }}
          >
            <SectionTitle
              style={{
                fontSize: '1.125rem',
                fontWeight: '600',
                color: '#111827',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                margin: '0',
                paddingBottom: '1.5rem',
              }}
            >
              <span>Purchase Information</span>
            </SectionTitle>
            <DcTag
              textColor={$DCSuccessColor}
              customBackgroundColor={$DCSuccessLightColor}
            >
              {purchaseSummary?.purchase_status?.status}
            </DcTag>
          </SectionHeader>
          <DcDiv height="auto">
            <DcFlexBox
              height="auto"
              justifyContent="space-between"
              padding="0px 24px"
            >
              <DcFlexBox
                height="auto"
                style={{
                  flexDirection: 'column',
                  gap: '0.25rem',
                }}
              >
                <PixelText
                  style={{
                    fontSize: '0.875rem',
                    fontWeight: '500',
                    color: '#6b7280',
                    margin: '0',
                  }}
                >
                  Purchase Date
                </PixelText>
                <PixelDate
                  className="textSmall"
                  value={purchaseSummary?.created_at?.date || '--'}
                  format={'pixelStandard'}
                />
              </DcFlexBox>
              <DcFlexBox
                height="auto"
                style={{
                  flexDirection: 'column',
                  gap: '0.25rem',
                }}
              >
                <PixelText
                  style={{
                    fontSize: '0.875rem',
                    fontWeight: '500',
                    color: '#6b7280',
                    margin: '0',
                  }}
                >
                  Supplier
                </PixelText>
                <PixelText>
                  {purchaseSummary?.supplier?.supplier_name || '--'}
                </PixelText>
              </DcFlexBox>
              <DcFlexBox
                height="auto"
                style={{
                  flexDirection: 'column',
                  gap: '0.25rem',
                }}
              >
                <PixelText
                  style={{
                    fontSize: '0.875rem',
                    fontWeight: '500',
                    color: '#6b7280',
                    margin: '0',
                  }}
                >
                  Reference No
                </PixelText>
                <PixelText>
                  {purchaseSummary?.reference_number || '--'}
                </PixelText>
              </DcFlexBox>
              <DcFlexBox
                height="auto"
                style={{
                  flexDirection: 'column',
                  gap: '0.25rem',
                }}
              >
                <PixelText
                  style={{
                    fontSize: '0.875rem',
                    fontWeight: '500',
                    color: '#6b7280',
                    margin: '0',
                  }}
                >
                  Warehouse
                </PixelText>
                <PixelText>
                  {purchaseSummary?.warehouse?.name || '--'}
                </PixelText>
              </DcFlexBox>
            </DcFlexBox>
          </DcDiv>
        </SectionContent>

        <SectionContent style={{ width: '30%' }}>
          <SectionHeader
            style={{
              padding: '1.5rem 1.5rem 0 1.5rem',
              borderBottom: '1px solid #f3f4f6',
              marginBottom: '1.5rem',
            }}
          >
            <SectionTitle
              style={{
                fontSize: '1.125rem',
                fontWeight: '600',
                color: '#111827',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                margin: '0',
                paddingBottom: '1.5rem',
              }}
            >
              Order Summary
            </SectionTitle>
          </SectionHeader>
          <DcFlexBox height="auto" flexDirection="column" padding="0px 24px">
            <DcFlexBox
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '0.25rem 0',
              }}
            >
              <PixelText
                style={{
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: '#6b7280',
                  margin: '0',
                }}
              >
                Total Products:
              </PixelText>
              <PixelText>
                {purchaseSummary?.purchase_items?.length || '--'}
              </PixelText>
            </DcFlexBox>
            <DcFlexBox
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '0.25rem 0',
              }}
            >
              <PixelText
                style={{
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: '#6b7280',
                  margin: '0',
                }}
              >
                Total Items:
              </PixelText>
              <PixelText>
                {purchaseSummary?.purchase_items?.reduce(
                  (acc, item) => acc + item.received_count,
                  0,
                )}
              </PixelText>
            </DcFlexBox>
            <DcFlexBox
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '0.25rem 0',
              }}
            >
              <PixelText
                style={{
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: '#6b7280',
                  margin: '0',
                }}
              >
                Total Cost:
              </PixelText>
              <PixelCurrency value={purchaseSummary?.total_amount} />
            </DcFlexBox>
          </DcFlexBox>
        </SectionContent>
      </DcFlexBox>
    </>
  )
}

export default PurchaseSummary
